if ($('.bereken-rente-trigger-js').length !== 0) {

	formName = '#bereken-rente';

	hideFieldsets = hideFieldsets;

	showFieldset = showFieldset;

	hideFieldset = hideFieldset;

	backButton = 'input#rente-back';

	nextButton = 'input#rente-submit';

	startText = 'div#verplichte-tekst';

	step = 1;

	showNextStep = showNextStep;

	showPreviousStep = showPreviousStep;

	setPreventDefault = setPreventDefault;


	function resetRente()
	{
		trigger = {};
		trigger.rente = 4.5;
		trigger.maxRente = 4.5;
		trigger.bandbreedte = 1;
		trigger.errorText = false;

		hoofdaanvrager = {};
		partner = {};
		hoofdaanvrager.extraMaxRente = 0;

		partner.extraMaxRente = 0;

	}

	function hideFieldsets()
	{
		$(formName).children('fieldset').hide();
	}

	function showFieldset(i)
	{
		$(formName+' fieldset.'+i).show();
	}

	function hideFieldset(i)
	{
		$(formName+' fieldset.'+i).hide();
	}

	function saveSessionValues(values)
	{
		$.ajax({
			url: '/ajax/saveSessionValues',
			data: {values: values},
			dataType: 'json',
			cache:false,
			timeout: 3000,
			tryCount : 0,
			retryLimit : 5,
			success: function(data, status){
				window.location.href = "/offerte-aanvragen/";
			},
			error: function(xhr, textStatus, errorThrown){
				if (textStatus == 'timeout') {
					this.tryCount++;
					if (this.tryCount <= this.retryLimit) {
						//try again
						$.ajax(this);
						return;
					}
					return;
				}
			}
		});
	}

	function addBox(leningtype, betalen, termijnbedrag, rente, counter)
	{
		var calc = TriggerCalculator();

		var leningtype = leningtype;
		var bedrag = betalen;
		var termijnbedrag = termijnbedrag.replace(',','.');;
		var debetrentevoet = rente.replace(',','.');
		var nominaal = calc.nominaal(debetrentevoet);
		var looptijd = calc.looptijd(bedrag, nominaal, termijnbedrag);
		var terugbetalen = parseFloat(looptijd*termijnbedrag);

		// console.log(bedrag);
		// console.log(termijnbedrag);
		// console.log(debetrentevoet);
		// console.log(nominaal);
		// console.log(looptijd);
		// console.log(terugbetalen);

		var boxNo = parseInt(counter);

		var html = "<table class='lopende-lening-table' id='"+boxNo+"'><thead><tr><th>"+leningtype+"</th><th>&euro;"+bedrag+"<a class='lening-delete' data-boxNo='"+boxNo+"'><img src='/img/icon_delete.png' alt='lening verwijderen'></a></th>";
			html+= "</tr></thead><tbody><tr><th>Termijnbedrag</th><td>&euro;"+termijnbedrag+"</td></tr>";
			html+= "<tr><th>Debetrentevoet</th><td>"+debetrentevoet+"%</td></tr>";
			html+= "<tr><th>Totaal terug te betalen</th><td>&euro;"+terugbetalen.toFixed(2)+"</td></tr></tbody></table>";

		$('div#lening-boxes').append(html);

		setPreventDefault('a.lening-delete');
	}

	function saveBox(leningtype, betalen, termijnbedrag, rente, counter)
	{

		var calc = TriggerCalculator();

		var leningtype = leningtype;
		var bedrag = betalen;
		var termijnbedrag = termijnbedrag.replace(',','.');
		var debetrentevoet = rente.replace(',','.');
		var nominaal = calc.nominaal(debetrentevoet);
		var looptijd = calc.looptijd(bedrag, nominaal, termijnbedrag);
		var terugbetalen = parseFloat(looptijd*termijnbedrag);

		var boxNo = parseInt(counter);

		$.ajax({
			url: '/ajax/saveLopendeLening',
			data: {boxNo: boxNo, leningtype: leningtype, bedrag: betalen, termijnbedrag: termijnbedrag, debetrentevoet: rente, terugbetalen: terugbetalen.toFixed(2)},
			dataType: 'json',
			cache:false,
			timeout: 3000,
			tryCount : 0,
			retryLimit : 5,
			success: function(data, status){
				console.log(data);
			},
			error: function(xhr, textStatus, errorThrown){
				if (textStatus == 'timeout') {
					this.tryCount++;
					if (this.tryCount <= this.retryLimit) {
						//try again
						$.ajax(this);
						return;
					}
					return;
				}
			}
		});
	}

	function removeBox(boxno)
	{
		console.log('table#'+boxno);
		$('table#'+boxno).remove();
	}
	function removeBoxSession(boxno)
	{
		$.ajax({
			url: '/ajax/removeLopendeLening',
			data: {boxNo: boxno},
			dataType: 'json',
			cache:false,
			timeout: 3000,
			tryCount : 0,
			retryLimit : 5,
			success: function(data, status){
				console.log(data);
			},
			error: function(xhr, textStatus, errorThrown){
				if (textStatus == 'timeout') {
					this.tryCount++;
					if (this.tryCount <= this.retryLimit) {
						//try again
						$.ajax(this);
						return;
					}
					return;
				}
			}
		});
	}

	function setResultStep()
	{
		$('div#rente-bedrag').hide(); //hide the rente indication

		if($('#rente-leenvorm').val() == "Doorlopend krediet")
		{
			var key = "Maandlast";
			var value = $('select#rente-maandbedrag').val();
		}else{
			var key = "Looptijd";
			var value = $('select#rente-termijn').val()+' maanden';
		}

		if(trigger.bandbreedte < 2)
		{
			trigger.bandbreedte = 2;
		}

		var html = "<thead><tr><th>Productvorm</th><th>"+$('#rente-leenvorm').val()+"</th></tr></thead><tbody><tr><th>Leenbedrag</th><td>&euro; "+ $().number_format($('#rente-leenbedrag').val(), {numberOfDecimals: 0, decimalSeparator: ',', thousandSeparator: '.'})+",-</td></tr><tr><th>"+key+"</th><td>"+value+"</td></tr><tr><th>Rente indicatie</th><td>"+trigger.rente+" - "+parseFloat(trigger.rente + trigger.bandbreedte)+"</td></tr></tbody>";

		$('div#resultaat table').html('');

		$('div#resultaat table').append(html);

		// $('div#rente-error p').html('Of bekijk hoe de indicatie van je rente tot stand is gekomen.');

		$('div#rente-error').next().hide();
		$('div#rente-error').next().next().hide();

		$('div#resultaat table').show();

		$('div#resultaat').show();

		$('div#rente-error').show();

		$('#rente-submit').bind('click.sendform', function(){
			window.location.href = "/berekenen/bereken-je-rente/";
		});
	}

	function stepHandler(step)
	{
		switch(step)
		{
		case 1:
		  	$('table.lopende-lening-table').hide();
		  	$('#rente-submit').val('Volgende');
			$('#rente-submit').unbind('click.sendform');
			$('a.button-stap-1').hide();
			$('p.tekst-stap-1').hide();
		  	break;
		case 2:
		 // 	if($('#rente-burgerlijkestaat').val() != "Samenwonend" && $('#rente-burgerlijkestaat').val() != "Gehuwd")
			// {
			// 	$('table.lopende-lening-table').show();
			// }else{
				$('table.lopende-lening-table').hide();
			//}
			$('#rente-submit').val('Volgende');
			$('a.button-stap-1').hide();
			$('#rente-submit').unbind('click.sendform');
		  	break;
	 	case 3:
		 	if($('#rente-burgerlijkestaat').val() != "Samenwonend" && $('#rente-burgerlijkestaat').val() != "Gehuwd")
			{
				$('table.lopende-lening-table').show();
			}else{
				$('table.lopende-lening-table').hide();
			}
			$('#rente-submit').val('Volgende');
			$('#rente-submit').unbind('click.sendform');
		  	break;
		case 4:
			if($('#rente-burgerlijkestaat').val() == "Samenwonend" && $('#rente-burgerlijkestaat').val() == "Gehuwd")
			{
				$('table.lopende-lening-table').show();
			}else{
				$('table.lopende-lening-table').hide();
			}
			$('div#rente-bedrag').show(); //show the rente indication in case of going from step 5 to 4
			$('#rente-submit').val('Volgende');
			$('#rente-submit').unbind('click.sendform');
			break;
		case 5:
			$('table.lopende-lening-table').hide();
			$('#rente-submit').val('Resultaat');
			$('div#rente-bedrag').hide(); //hide the rente indication
			setResultStep();
			break;
		case 6:
			$('table.lopende-lening-table').hide();
			break;
		default:
		  	$('table.lopende-lening-table').hide();
		}
	}

	function showNextStep()
	{

		$(nextButton).click(function(){
			if($('form#bereken-rente').validate().form()){
				console.log("STEP: "+step);

				stepHandler(step);

				if(step != 6){

					hideFieldset(step);

					if(step == 2 && $('#rente-burgerlijkestaat').val() != "Samenwonend" && $('#rente-burgerlijkestaat').val() != "Gehuwd")
					{
						step = (step+2);
					}else{
						step = (step+1);
					}
					showFieldset(step);
				}

				$(backButton).show(); //show the backbutton, it's hidden at start and is hidden by its own function when the trigger is on page one
				$(startText).hide();
			}
		});
	}

	function showPreviousStep()
	{
		$(backButton).click(function(){

			$('#rente-submit').val('Volgende');
			$('#rente-submit').unbind('click.sendform');
			$('table.lopende-lening-table').hide();

			if(step != 1){
				hideFieldset(step);

				if(step == 4 && $('#rente-burgerlijkestaat').val() != "Samenwonend" && $('#rente-burgerlijkestaat').val() != "Gehuwd")
				{
					step = (step-2);
				}else{
					step = (step-1);
				}
				showFieldset(step);
			}

			if(step < 2)
			{
				$(backButton).hide();
				$(startText).show();
				$('a.button-stap-1').show();
				$('p.tekst-stap-1').show();
			}
		});
	}

	function setPreventDefault(elem)
	{
		$(elem).click(function(event){
			event.preventDefault();
		});
	}

	function updateFields(setElem)
	{

		var e = setElem //the changed element

		if(e == "rente-burgerlijkestaat" || e == "reset")
		{
			//burgelijke staat
			if($('#rente-burgerlijkestaat').val() == "Gehuwd")
			{
				$('div.samenwonendsinds').show();
				$('div.samenwonendsinds').children('label').html('Gehuwd sinds?');
			}else if ($('#rente-burgerlijkestaat').val() == "Samenwonend"){
				$('div.samenwonendsinds').show();
				$('div.samenwonendsinds').children('label').html('Samenwonend sinds?');
			}else{
				$('div.samenwonendsinds').hide();
			}
		}

		if(setElem == "rente-leenbedrag" || e == "rente-leenvorm" || e == "reset")
		{
			if($('#rente-leenvorm').val() == "Persoonlijke lening")
			{
				$('#rente-maandbedrag').hide();
				$('#rente-termijn-eigenhuispl').hide();
				$('#rente-termijn').show();

			}else if($('#rente-leenvorm').val() == "Eigenhuis Persoonlijke lening")
			{
				$('#rente-maandbedrag').hide();
				$('#rente-termijn').hide();
				$('#rente-termijn-eigenhuispl').show();
			}else if($('#rente-leenvorm').val() == "Doorlopend krediet" || $('#rente-leenvorm').val() == "WOZ krediet" || $('#rente-leenvorm').val() == 'Eigenhuis Doorlopend krediet')
			{
				var index = $("select#rente-maandbedrag option:selected").index();

				if(e == "reset")
				{
					index = 1;
				}

				$('select#rente-maandbedrag').html('<option value="">Maak uw keuze</option>'); //reset options

				var maandlastValues = setMaandlastValues(); //calculate values for the maandlast options

				//make and append the options
				for (var key in maandlastValues) {
				 	if (maandlastValues.hasOwnProperty(key)) {
				 		var option = "<option value='"+maandlastValues[key]+"'>&euro; "+maandlastValues[key]+"</option>";
				    	$('select#rente-maandbedrag').append(option);
				  	}
				}

				$('select#rente-maandbedrag').children().eq(index).attr('selected', true);

				// if($('select#rente-maandbedrag') !== undefined)
				// 	$.uniform.update('select#rente-maandbedrag');

				s = elemsize();
				s.setSelectboxWidth('.trigger-box form');

				$('#rente-termijn').hide(); //hide looptijd select
				$('#rente-termijn-eigenhuispl').hide();
				$('#rente-maandbedrag').show(); //show the maandlast select
			}else{
				$('#rente-termijn').hide();
				$('#rente-maandbedrag').hide();
			}
		}

		if(setElem == "rente-woonsituatie" || e == "reset")
		{
			//woonsituatie
			if($('#rente-woonsituatie').val() == "Koopwoning" || $('#rente-woonsituatie').val() == "Huurwoning" || $('#rente-woonsituatie').val() == "Inwonend")
			{
				$('div.woontsinds').show();

				$('div.woonkosten').show();

				if($('#rente-woonsituatie').val() == "Koopwoning")
				{
					$('div.kinderen').show();

					$('div.woonkosten').children('label').html('Bruto hypotheeklast p/m');
				}else if($('#rente-woonsituatie').val() == "Huurwoning")
				{
					$('div.kinderen').show();

					$('div.woonkosten').children('label').html('Kale huur p/m');
				}else if($('#rente-woonsituatie').val() == "Inwonend")
				{
					$('div.woonkosten').children('label').html('Kostgeld p/m');
				}

			}else{
				$('div.kinderen').hide();
				$('div.woontsinds').hide();
				$('div.woonkosten').hide();
			}
		}

		if(setElem == "rente-dienstverband" || e == "reset")
		{
			if($('#rente-dienstverband').val() == "07")
			{
				$('div.werkzaamsinds').hide();
			}else{
				$('div.werkzaamsinds').show();

				if($('#rente-dienstverband').val() == "18")
				{
					$('div.werkzaamsinds label').html('Ingangsdatum:');
					$('input#rente-inkomen').prev().html('Netto pensioen per maand:')
				}else if($('#rente-dienstverband').val() == "19")
				{
					$('div.werkzaamsinds label').html('Ingangsdatum:');
					$('input#rente-inkomen').prev().html('Netto WAO uitkering:')

				}else if($('#rente-dienstverband').val() == "21")
				{
					$('div.werkzaamsinds label').html('Uitkering sinds:');
					$('input#rente-inkomen').prev().html('Netto inkomen per maand:')

				}else if($('#rente-dienstverband').val() == "01" || $('#rente-dienstverband').val() == "03" || $('#rente-dienstverband').val() == "09")
				{
					$('div.werkzaamsinds label').html('Datum in dienst:');
					$('input#rente-inkomen').prev().html('Netto salaris per maand:')
				}else if($('#rente-dienstverband').val() == "05")
				{
					$('input#rente-inkomen').prev().html('Belastbaar jaarinkomen:')
					$('div.werkzaamsinds label').html('Zelfstandig sinds:');
				}else{
					$('div.werkzaamsinds label').html('Werkzaam sinds:');
					$('input#rente-inkomen').prev().html('Netto salaris per maand:')
				}

			}
		}

		if(setElem == "rente-dienstverband-partner" || e == "reset")
		{
			if($('#rente-dienstverband-partner').val() == "07")
			{
				$('div.werkzaamsinds-partner').hide();
			}else{
				$('div.werkzaamsinds-partner').show();

				if($('#rente-dienstverband-partner').val() == "18")
				{
					$('div.werkzaamsinds-partner label').html('Ingangsdatum:');
					$('input#rente-inkomen-partner').prev().html('Netto pensioen per maand:')
				}else if($('#rente-dienstverband-partner').val() == "19")
				{
					$('div.werkzaamsinds-partner label').html('Ingangsdatum:');
					$('input#rente-inkomen-partner').prev().html('Netto WAO uitkering:')

				}else if($('#rente-dienstverband-partner').val() == "21")
				{
					$('div.werkzaamsinds-partner label').html('Uitkering sinds:');
					$('input#rente-inkomen-partner').prev().html('Netto inkomen per maand:')

				}else if($('#rente-dienstverband-partner').val() == "01" || $('#rente-dienstverband-partner').val() == "03" || $('#rente-dienstverband-partner').val() == "09")
				{
					$('div.werkzaamsinds-partner label').html('Datum in dienst:');
					$('input#rente-inkomen-partner').prev().html('Netto salaris per maand:')
				}else if($('#rente-dienstverband-partner').val() == "05")
				{
					$('input#rente-inkomen-partner').prev().html('Belastbaar jaarinkomen:')
					$('div.werkzaamsinds-partner label').html('Zelfstandig sinds:');
				}else{
					$('div.werkzaamsinds-partner label').html('Werkzaak sinds:');
					$('input#rente-inkomen-partner').prev().html('Netto salaris per maand:')
				}

			}
		}

		if(setElem == "rente-leenervaring" || e == "reset")
		{
			//lopende leningen
			if($('#rente-leenervaring').val() == "Op dit moment heb ik lopende lening(en)")
			{
				$('div.lopende-leningen').show();
			}else{
				$('div.lopende-leningen').hide();
			}
		}

	}

	function saveRenteObj(renteObj)
	{
		$.ajax({
			url: '/ajax/saveRenteVerloop',
			data: {value: renteObj},
			dataType: 'json',
			cache:false,
			timeout: 3000,
			tryCount : 0,
			retryLimit : 5,
			success: function(data, status){
				//window.location.href = 'http://nederlandskredietcollectief.nl/jouw-mogelijkheden/berekenen/bereken-je-rente/';
				console.log("success");
			},
			error: function(xhr, textStatus, errorThrown){
				if (textStatus == 'timeout') {
					this.tryCount++;
					if (this.tryCount <= this.retryLimit) {
						//try again
						$.ajax(this);
						return;
					}
					return;
				}
			}
		});
	}

	function displayRente(rente, maxRente, bandbreedte, errorText)
	{
		var renteVanElem = '#rente-van';
		var renteTotElem = '#rente-tot';

		if(rente.toString().length == 4)
		{
			$(renteVanElem).html(rente+'%');
		}else if(rente.toString().length > 4){
			if(rente.toString().substr(4,1) == "0")
			{
				$(renteVanElem).html(rente.toFixed(1)+'%');
			}else{
				$(renteVanElem).html(rente.toFixed(2)+'%');
			}
		}else{
			$(renteVanElem).html(rente+'%');
		}

		if(bandbreedte < 2)
		{
			bandbreedte = 2;
		}

		var rentetot = parseFloat(rente+2);


		if(rentetot > 15){
			rentetot = 15;
			$(renteTotElem).html(rentetot+'%');
		}else{
			if(rentetot.toString().length == 4)
			{
				$(renteTotElem).html(rentetot+'%');
			}else if(rentetot.toString().length > 4)
			{
				if(rentetot.toString().substr(4,1) == "0")
				{
					$(renteTotElem).html(rentetot.toFixed(1)+'%');
				}else{
					$(renteTotElem).html(rentetot.toFixed(2)+'%');
				}
			}else{
				$(renteTotElem).html(rentetot.toFixed(1)+'%');
			}
		}

		if(errorText)
		{
			$('#rente-bedrag').hide();
			$('#rente-error').children('p').html(errorText);
			$('#rente-error').show();
		}else{
			$('#rente-error').hide();
			$('#rente-bedrag').show();
		}

	}

	function setMaandlastValues()
	{
		var val = $('#rente-leenbedrag').val();

		if(val != "" && val > 0)
		{
			return maandlastObj = {
				0 : (val * 0.010),
				1 : (val * 0.015),
				2 : (val * 0.020)
			}
		}
	}

	function makeJsonPart(fieldname, val, rente, bandbreedte, start, end)
	{
		if(start === true)
		{
			trigger.jsonInfo = '{ "'+fieldname+'" : {"name" : "'+fieldname+'", "fieldval" : "'+val+'", "rentediff" : "'+rente.toFixed(2)+'", "bandbreedtediff" : "'+bandbreedte+'"},';
		}else if(end === true){
			trigger.jsonInfo += '"'+fieldname+'" : {"name" : "'+fieldname+'", "fieldval" : "'+val+'", "rentediff" : "'+rente.toFixed(2)+'", "bandbreedtediff" : "'+bandbreedte+'"}}';
		}else{
			trigger.jsonInfo += '"'+fieldname+'" : {"name" : "'+fieldname+'", "fieldval" : "'+val+'", "rentediff" : "'+rente.toFixed(2)+'", "bandbreedtediff" : "'+bandbreedte+'"},';
		}
	}

	function setNewRente(plus)
	{
		trigger.rente = trigger.rente+plus;
	}

	function setNewBandbreedte(plus)
	{
		trigger.bandbreedte = trigger.bandbreedte+plus;
	}

	function setNewMaxRente(plus)
	{
		trigger.maxRente = trigger.maxRente+plus;
	}


	var TriggerCalculator = function ()
	{
		return {

			leenbedrag: function()
			{
				var val = $('#rente-leenbedrag').val();

				if(val == "" || val === undefined)
				{
					extraRente = 0.00;
					extraBandreedte = 0.00;
					extraMaxRente = 2.80;

				}else if(val >= 5000 && val <= 9999)
				{
					extraRente = 2.80;
					extraBandreedte = 0.00;
					extraMaxRente = 2.80;

				}else if(val >= 10000 && val <= 14999)
				{
					extraRente = 1.60;
					extraBandreedte = 0.00;
					extraMaxRente = 1.60;

				}else if(val >= 15000 && val <= 24999)
				{
					extraRente = 0.20;
					extraBandreedte = 0.00;
					extraMaxRente = 0.20;

				}else if(val >= 25000)
				{
					extraRente = 0.00;
					extraBandreedte = 0.00;
					extraMaxRente = 0.00;
				}else{

				}

				setNewRente(extraRente);
				setNewBandbreedte(extraBandreedte);
				setNewMaxRente(extraMaxRente);
				makeJsonPart("LeningBedrag", val, extraRente, extraBandreedte, true, false);
			},

			productkeuze: function()
			{
				var val = $('#rente-leenvorm').val();

				if(val == "Persoonlijke lening")
				{
					var looptijd = $('select#rente-termijn').val();

					if(looptijd != "" && looptijd != undefined){
						$.ajaxSetup({
							async: false
						});

						$.get("/ajax/rente_dnkm.php", {
							product: val.toLowerCase(),
							leenbedrag: $('#rente-leenbedrag').val(),
							looptijd: looptijd,
							maandlast: 0
						}, function(data){
							data = Math.round(Number(data.split(";")[1]) * 10) / 10;
							var value = Math.round((data) * 10) / 10;

							extraRente = value - trigger.rente;
							extraBandreedte = 0.00;

							setNewRente(extraRente);
							setNewMaxRente(extraRente);
							setNewBandbreedte(extraBandreedte);
							makeJsonPart("productvorm", val, extraRente, extraBandreedte, false, false);
							makeJsonPart("looptijd", looptijd, extraRente, extraBandreedte, false, false);
							makeJsonPart("basisrente", value, extraRente, extraBandreedte, false, false);
							$.ajaxSetup({
								async: true
							});
						});
					}else{
						setNewRente(0.20);
						setNewMaxRente(0.20);
						makeJsonPart("productvorm", val, 0.20, 0.00, false, false);
					}

				}else if(val == "Doorlopend krediet")
				{
					var maandlast = $('select#rente-maandbedrag').val();

					//if(maandlast != "" && maandlast != undefined){
						$.ajaxSetup({
							async: false
						});

						$.get("/ajax/rente_dnkm.php", {
							product: val.toLowerCase(),
							leenbedrag: $('#rente-leenbedrag').val(),
							looptijd: 0,
							maandlast: 0
						}, function(data){
							data = Math.round(Number(data.split(";")[1]) * 10) / 10;
							var value = Math.round((data) * 10) / 10;

							extraRente = value - trigger.rente;
							extraBandreedte = 0.00;

							setNewRente(extraRente);
							setNewMaxRente(extraRente);
							setNewBandbreedte(extraBandreedte);
							makeJsonPart("productvorm", val, extraRente, extraBandreedte, false, false);
							makeJsonPart("maandlast", maandlast, extraRente, extraBandreedte, false, false);
							makeJsonPart("basisrente", value, extraRente, extraBandreedte, false, false);
							$.ajaxSetup({
								async: true
							});
						});
					//}

				}else if(val == "WOZ krediet")
				{
					var maandlast = $('select#rente-maandbedrag').val();

					//if(maandlast != "" && maandlast != undefined){
						$.ajaxSetup({
							async: false
						});

						$.get("/ajax/rente_dnkm.php", {
							product: "doorlopend krediet",
							leenbedrag: $('#rente-leenbedrag').val(),
							looptijd: 0,
							maandlast: 0,
							type: val
						}, function(data){
							data = Math.round(Number(data.split(";")[1]) * 10) / 10;
							var value = Math.round((data) * 10) / 10;

							extraRente = value - trigger.rente;
							extraBandreedte = 0.00;

							setNewRente(extraRente);
							setNewMaxRente(extraRente);
							setNewBandbreedte(extraBandreedte);
							makeJsonPart("productvorm", val, extraRente, extraBandreedte, false, false);
							makeJsonPart("maandlast", maandlast, extraRente, extraBandreedte, false, false);
							makeJsonPart("basisrente", value, extraRente, extraBandreedte, false, false);
							$.ajaxSetup({
								async: true
							});
						});
					//}
				}else if(val == "Eigenhuis Doorlopend krediet")
				{
					var maandlast = $('select#rente-maandbedrag').val();

					//if(maandlast != "" && maandlast != undefined){
						$.ajaxSetup({
							async: false
						});

						$.get("/ajax/rente_dnkm.php", {
							product: "doorlopend krediet",
							leenbedrag: $('#rente-leenbedrag').val(),
							looptijd: 0,
							maandlast: 0,
							type: val
						}, function(data){
							data = Math.round(Number(data.split(";")[1]) * 10) / 10;
							var value = Math.round((data) * 10) / 10;

							extraRente = value - trigger.rente;
							extraBandreedte = 0.00;

							setNewRente(extraRente);
							setNewMaxRente(extraRente);
							setNewBandbreedte(extraBandreedte);
							makeJsonPart("productvorm", val, extraRente, extraBandreedte, false, false);
							makeJsonPart("maandlast", maandlast, extraRente, extraBandreedte, false, false);
							makeJsonPart("basisrente", value, extraRente, extraBandreedte, false, false);
							$.ajaxSetup({
								async: true
							});
						});
					//}
				}else if(val == "Eigenhuis Persoonlijke lening")
				{
					var looptijd = $('select#rente-termijn-eigenhuispl').val();

					if(looptijd != "" && looptijd != undefined){
						$.ajaxSetup({
							async: false
						});

						$.get("/ajax/rente_dnkm.php", {
							product: val.toLowerCase(),
							leenbedrag: $('#rente-leenbedrag').val(),
							looptijd: looptijd,
							maandlast: 0,
							type: val
						}, function(data){
							data = Math.round(Number(data.split(";")[1]) * 10) / 10;
							var value = Math.round((data) * 10) / 10;

							extraRente = value - trigger.rente;
							extraBandreedte = 0.00;

							setNewRente(extraRente);
							setNewMaxRente(extraRente);
							setNewBandbreedte(extraBandreedte);
							makeJsonPart("productvorm", val, extraRente, extraBandreedte, false, false);
							makeJsonPart("looptijd", looptijd, extraRente, extraBandreedte, false, false);
							makeJsonPart("basisrente", value, extraRente, extraBandreedte, false, false);
							$.ajaxSetup({
								async: true
							});
						});
					}else{
						setNewRente(0.20);
						setNewMaxRente(0.20);
						makeJsonPart("productvorm", val, 0.20, 0.00, false, false);
					}

				}else if(val == "Weet ik niet")
				{
					setNewRente(0.20);
					setNewBandbreedte(0.00);
					setNewMaxRente(0.20);
					makeJsonPart("productvorm", val, 0.20, 0.00, false, false);
				}else{
					//do nothing
				}
			},

			geboortedatum: function()
			{
				var birthdate = $('#rente-geboortedatum').val();
				if(birthdate != "" && birthdate != "__-__-____"){
					var year = Number(birthdate.substr(6,4));
					var month = Number(birthdate.substr(3,2))-1;
					var day = Number(birthdate.substr(0,2));
					var today = new Date();
					var age = today.getFullYear()-year;
					if(today.getMonth()<month || (today.getMonth()==month && today.getDate()<day)){age--;}
					var val = age;
				}else{
					var val = "undefined";
				}

				if(val == "undefined")
				{
					hoofdaanvrager.extraRente = 0.00;
					hoofdaanvrager.extraBandbreedte = 2.00;
					hoofdaanvrager.extraMaxRente = 1.00;

				}else if(val < 25)
				{
					hoofdaanvrager.extraRente = 1.00;
					hoofdaanvrager.extraBandbreedte = 2.00;
					hoofdaanvrager.extraMaxRente = 1.00;

				}else if(val >= 25 && val <= 55)
				{

					hoofdaanvrager.extraRente = 0.00;
					hoofdaanvrager.extraBandbreedte = 0.00;
					hoofdaanvrager.extraMaxRente = 0.00;

				}else if(val > 55){

					hoofdaanvrager.extraRente = 0.00;
					hoofdaanvrager.extraBandbreedte = 0.50;
					hoofdaanvrager.extraMaxRente = 0.00;
				}

				//setNewRente(extraRente);
				//setNewBandbreedte(extraBandreedte);
				//setNewMaxRente(extraMaxRente);
				makeJsonPart("1_GeboorteDt", birthdate, hoofdaanvrager.extraRente, hoofdaanvrager.extraBandbreedte, false, false);

			},

			geboortedatum_partner: function()
			{
				if($('#rente-burgerlijkestaat').val() == "")
				{
						partner.extraRente = 0.00;
						partner.extraBandbreedte = 2.00;
						partner.extraMaxRente = 1.00;
				}
				if($('#rente-burgerlijkestaat').val() == "Samenwonend" || $('#rente-burgerlijkestaat').val() == "Gehuwd")
				{
					var birthdate = $('#geboortedatum-partner').val();
					if(birthdate != "" && birthdate != "__-__-____"){
						var year = Number(birthdate.substr(6,4));
						var month = Number(birthdate.substr(3,2))-1;
						var day = Number(birthdate.substr(0,2));
						var today = new Date();
						var age = today.getFullYear()-year;
						if(today.getMonth()<month || (today.getMonth()==month && today.getDate()<day)){age--;}
						var val = age;
					}else{
						var val = "undefined";
					}

					if(val == "undefined")
					{
						partner.extraRente = 0.00;
						partner.extraBandbreedte = 2.00;
						partner.extraMaxRente = 1.00;
					}
					else if(val == 0)
					{
						partner.extraRente = 0.00;
						partner.extraBandbreedte = 1.00;
						partner.extraMaxRente = 1.00;

					}else if(val < 25)
					{
						partner.extraRente = 1.00;
						partner.extraBandbreedte = 2.00;
						partner.extraMaxRente = 1.00;

					}else if(val >= 25 && val <= 55)
					{

						partner.extraRente = 0.00;
						partner.extraBandbreedte = 0.00;
						partner.extraMaxRente = 0.00;

					}else if(val > 55){

						partner.extraRente = 0.00;
						partner.extraBandbreedte = 0.50;
						partner.extraMaxRente = 0.00;
					}
					makeJsonPart("2_GeboorteDt", birthdate, partner.extraRente, partner.extraBandbreedte, false, false);
				}

					//setNewRente(extraRente);
					//setNewBandbreedte(extraBandreedte);
					//setNewMaxRente(extraMaxRente);

			},

			burgelijkestaat: function()
			{
				var val = $('#rente-burgerlijkestaat').val();

				if(val == "Ongehuwd" || val == "Weduw(e/naar)")
				{
					extraBandbreedte = 0.25;
					extraRente = 0.00;
					extraMaxRente = 0.00;
				}else if(val == "Gehuwd" || val == "Samenwonend")
				{
					extraBandbreedte = 0.00;
					extraRente = 0.00;
					extraMaxRente = 0.00;
				}else{
					extraBandbreedte = 0.25;
					extraRente = 0.00;
					extraMaxRente = 0.00;
				}

				setNewRente(extraRente);
				setNewBandbreedte(extraBandbreedte);
				setNewMaxRente(extraMaxRente);
				makeJsonPart("1_BurgerlijkeStaat", val, extraRente, extraBandbreedte, false, false);
			},

			duurBurgelijkestaat: function()
			{
				if($('#rente-burgerlijkestaat').val() == "")
				{
					extraBandreedte = 0.50;
					extraRente = 0.00;
					extraMaxRente = 0.00;
				}
				else if($('#rente-burgerlijkestaat').val() == "Samenwonend" || $('#rente-burgerlijkestaat').val() == "Gehuwd")
				{
					var birthdate = $('#samenwonendsinds').val();
					if(birthdate != "" && birthdate != undefined && birthdate != "__-__-____"){
						var year = Number(birthdate.substr(6,4));
						var month = Number(birthdate.substr(3,2))-1;
						var day = Number(birthdate.substr(0,2));
						var today = new Date();
						var age = today.getFullYear()-year;
						if(today.getMonth()<month || (today.getMonth()==month && today.getDate()<day)){age--;}
						var val = age;
					}else{
						var val = 0;
					}

					if(val == 0){
						extraBandreedte = 0.50;
						extraRente = 0.00;
						extraMaxRente = 0.00;
					}else if(val < 2)
					{
						extraBandreedte = 0.50;
						extraRente = 0.00;
						extraMaxRente = 0.00;
					}else if(val >= 2 && val <= 10)
					{
						extraBandreedte = 0.20;
						extraRente = 0.00;
						extraMaxRente = 0.00;
					}else if(val > 10){
						extraBandreedte = 0.00;
						extraRente = 0.00;
						extraMaxRente = 0.00;
					}
					makeJsonPart("1_BurgelijkeStaatDt", birthdate, extraRente, extraBandreedte, false, false);
				}
					setNewRente(extraRente);
					setNewBandbreedte(extraBandreedte);
					setNewMaxRente(extraMaxRente);
			},

			woonsituatie: function()
			{
				var val = $('#rente-woonsituatie').val();

				if(val == "Koopwoning")
				{
					extraBandreedte = 0.00;
					extraRente = 0.00;
					extraMaxRente = 0.00;
				}else if(val == "Huurwoning")
				{
					extraBandreedte = 0.00;
					extraRente = 0.20;
					extraMaxRente = 0.20;
				}else if(val == "Inwonend" || val == "Thuiswonend")
				{
					extraBandreedte = 3.00;
					extraRente = 1.50;
					extraMaxRente = 1.50;
				}else{
					extraBandreedte = 2.00;
					extraRente = 0.00;
					extraMaxRente = 1.50;
				}

				setNewRente(extraRente);
				setNewBandbreedte(extraBandreedte);
				setNewMaxRente(extraMaxRente);
				makeJsonPart("1_FinancieleSituatieWoonSituatie", val, extraRente, extraBandreedte, false, false);
			},

			duurWoonsituatie: function()
			{
				var birthdate = $('#rente-woontsinds').val();
				if(birthdate != "" && birthdate != "__-__-____"){
					var year = Number(birthdate.substr(6,4));
					var month = Number(birthdate.substr(3,2))-1;
					var day = Number(birthdate.substr(0,2));
					var today = new Date();
					var age = today.getFullYear()-year;
					if(today.getMonth()<month || (today.getMonth()==month && today.getDate()<day)){age--;}
					var val = age;
				}else{
					var val = "undefined";
				}

				if(val == "undefined")
				{
					extraBandbreedte = 0.50;
					extraRente = 0.00;
					extraMaxRente = 0.00;
				} else if($('#rente-woonsituatie').val() == "Koopwoning" || $('#rente-woonsituatie').val() == "Huurwoning")
				{
					if(val < 2)
					{
						extraBandbreedte = 0.50;
						extraRente = 0.00;
						extraMaxRente = 0.00;
					}else if(val >= 2 && val <= 10)
					{
						extraBandbreedte = 0.20;
						extraRente = 0.00;
						extraMaxRente = 0.00;
					}else if(val > 10)
					{
						extraBandbreedte = 0.00;
						extraRente = 0.00;
						extraMaxRente = 0.00;
					}else{
						extraBandbreedte = 0.50;
						extraRente = 0.00;
						extraMaxRente = 0.00;
					}

					makeJsonPart("1_FinancieleSituatieWoonSituatieDt", birthdate, extraRente, extraBandbreedte, false, false);
				}
				setNewRente(extraRente);
				setNewBandbreedte(extraBandbreedte);
				setNewMaxRente(extraMaxRente);
				makeJsonPart("1_FinancieleSituatieWoonSituatieDt", birthdate, 0.00, 0.00, false, false);
			},

			dienstverband: function()
			{

				var val = $("#rente-dienstverband").val();

				//calculate the rente with the proper dienstverband value

				if(val == "18") //pensioen lijfrente
				{
					hoofdaanvrager.extraBandbreedte = hoofdaanvrager.extraBandbreedte + 2.00;
					hoofdaanvrager.extraRente = hoofdaanvrager.extraRente + 0.50;
					hoofdaanvrager.extraMaxRente = hoofdaanvrager.extraMaxRente + 0.50;
					makeJsonPart("1_AardDienstverband", $("#rente-dienstverband").val(), 0.50, 2.00, false, false);

				}else if(val == "03" || val == "09") //jaarcontract
				{
					hoofdaanvrager.extraBandbreedte = hoofdaanvrager.extraBandbreedte + 1.00;
					hoofdaanvrager.extraRente = hoofdaanvrager.extraRente + 1.00;
					hoofdaanvrager.extraMaxRente = hoofdaanvrager.extraMaxRente + 1.00;
					makeJsonPart("1_AardDienstverband", $("#rente-dienstverband").val(), 1.00, 1.00, false, false);

				}else if(val == "01" || val == "19") //onbepaalde tijd
				{
					hoofdaanvrager.extraBandbreedte = hoofdaanvrager.extraBandbreedte + 0.00;
					hoofdaanvrager.extraRente = hoofdaanvrager.extraRente + 0.00;
					hoofdaanvrager.extraMaxRente = hoofdaanvrager.extraMaxRente + 0.00;
					makeJsonPart("1_AardDienstverband", $("#rente-dienstverband").val(), 0.00, 0.00, false, false);

				}else if(val =="05" || val == "21" || val == "07")
				{
					hoofdaanvrager.extraMaxRente = hoofdaanvrager.extraMaxRente + 10.00;
				}
				else{
					hoofdaanvrager.extraBandbreedte = hoofdaanvrager.extraBandbreedte + 2.00;
					hoofdaanvrager.extraRente = hoofdaanvrager.extraRente + 0.00;
					hoofdaanvrager.extraMaxRente = hoofdaanvrager.extraMaxRente + 1.00;
					makeJsonPart("1_AardDienstverband", $("#rente-dienstverband").val(), 0.00, 2.00, false, false);
				}

				//makeJsonPart("2_AardDienstverband", $("#rente-dienstverband-partner").val(), extraRente, extraBandbreedte, false, false);

			},

			dienstverband_partner: function()
			{

				var val = $("#rente-dienstverband-partner").val();

				//calculate the rente with the proper dienstverband value

				if(val == "18") //pensioen lijfrente
				{
					partner.extraBandbreedte = partner.extraBandbreedte + 2.00;
					partner.extraRente = partner.extraRente + 0.50;
					partner.extraMaxRente = partner.extraMaxRente + 0.50;
					makeJsonPart("2_AardDienstverband", $("#rente-dienstverband-partner").val(), 0.50, 2.00, false, false);

				}else if(val == "03" || val == "09") //jaarcontract
				{
					partner.extraBandbreedte = partner.extraBandbreedte + 1.00;
					partner.extraRente = partner.extraRente + 1.00;
					partner.extraMaxRente = partner.extraMaxRente + 1.00;
					makeJsonPart("2_AardDienstverband", $("#rente-dienstverband-partner").val(), 1.00, 1.00, false, false);

				}else if(val == "01" || val == "19") //onbepaalde tijd
				{
					partner.extraBandbreedte = partner.extraBandbreedte + 0.00;
					partner.extraRente = partner.extraRente + 0.00;
					partner.extraMaxRente = partner.extraMaxRente + 0.00;
					makeJsonPart("2_AardDienstverband", $("#rente-dienstverband-partner").val(), 0.00, 0.00, false, false);

				}else if(val =="05" || val == "21" || val == "07")
				{
					partner.extraMaxRente = partner.extraMaxRente + 10.00;
				}
				else{
					partner.extraBandbreedte = partner.extraBandbreedte + 2.00;
					partner.extraRente = partner.extraRente + 0.00;
					partner.extraMaxRente = partner.extraMaxRente + 1.00;
					makeJsonPart("2_AardDienstverband", $("#rente-dienstverband-partner").val(), 0.00, 2.00, false, false);
				}

				//makeJsonPart("1_AardDienstverband", $("#rente-dienstverband").val(), extraRente, extraBandbreedte, false, false);
				//makeJsonPart("2_AardDienstverband", $("#rente-dienstverband-partner").val(), partner.extraRente, partner.extraBandbreedte, false, false);

			},

			duurDienstverband: function()
			{

				var startdate = $('#rente-werkzaamsinds').val();

				var birthdate = startdate;
				if(birthdate != "" && birthdate != "__-__-____"){
					var year = Number(birthdate.substr(6,4));
					var month = Number(birthdate.substr(3,2))-1;
					var day = Number(birthdate.substr(0,2));
					var today = new Date();
					var age = today.getFullYear()-year;
					if(today.getMonth()<month || (today.getMonth()==month && today.getDate()<day)){age--;}
					var val = age;
				}else{
					var val = "undefined";
				}

				if(val == "undefined")
				{
					hoofdaanvrager.extraBandbreedte = hoofdaanvrager.extraBandbreedte + 0.50;
					hoofdaanvrager.extraRente = hoofdaanvrager.extraRente + 0.00;
					hoofdaanvrager.extraMaxRente = hoofdaanvrager.extraMaxRente + 0.00;
					makeJsonPart("1_BeginDienstverbandDt", $('#rente-werkzaamsinds').val(), 0.00, 0.50, false, false);
				}else if(val < 2)
				{
					hoofdaanvrager.extraBandbreedte = hoofdaanvrager.extraBandbreedte + 0.50;
					hoofdaanvrager.extraRente = hoofdaanvrager.extraRente + 0.00;
					hoofdaanvrager.extraMaxRente = hoofdaanvrager.extraMaxRente + 0.00;
					makeJsonPart("1_BeginDienstverbandDt", $('#rente-werkzaamsinds').val(), 0.00, 0.50, false, false);
				}else if(val >= 2 && val <= 5)
				{
					hoofdaanvrager.extraBandbreedte = hoofdaanvrager.extraBandbreedte + 0.20;
					hoofdaanvrager.extraRente = hoofdaanvrager.extraRente + 0.00;
					hoofdaanvrager.extraMaxRente = hoofdaanvrager.extraMaxRente + 0.00;
					makeJsonPart("1_BeginDienstverbandDt", $('#rente-werkzaamsinds').val(), 0.00, 0.20, false, false);
				}else if(val > 5)
				{
					hoofdaanvrager.extraBandbreedte = hoofdaanvrager.extraBandbreedte + 0.00;
					hoofdaanvrager.extraRente = hoofdaanvrager.extraRente+ 0.00;
					hoofdaanvrager.extraMaxRente = hoofdaanvrager.extraMaxRente + 0.00;
					makeJsonPart("1_BeginDienstverbandDt", $('#rente-werkzaamsinds').val(), 0.00, 0.00, false, false);
				}else{
					hoofdaanvrager.extraBandbreedte = hoofdaanvrager.extraBandbreedte + 0.50;
					hoofdaanvrager.extraRente =  hoofdaanvrager.extraRente+ 0.00;
					hoofdaanvrager.extraMaxRente =  hoofdaanvrager.extraMaxRente + 0.00;
					makeJsonPart("1_BeginDienstverbandDt", $('#rente-werkzaamsinds').val(), 0.00, 0.50, false, false);
				}

				//makeJsonPart("2_BeginDienstverbandDt", $('#rente-werkzaamsinds-partner').val(), extraRente, extraBandbreedte, false, false);
			},

			duurDienstverband_partner: function()
			{
				var startdate = $('#rente-werkzaamsinds-partner').val();

				var birthdate = startdate;
				if(birthdate != "" && birthdate != "__-__-____"){
					var year = Number(birthdate.substr(6,4));
					var month = Number(birthdate.substr(3,2))-1;
					var day = Number(birthdate.substr(0,2));
					var today = new Date();
					var age = today.getFullYear()-year;
					if(today.getMonth()<month || (today.getMonth()==month && today.getDate()<day)){age--;}
					var val = age;
				}else{
					var val = "undefined";
				}

				if(val == "undefined")
				{
					partner.extraBandbreedte = partner.extraBandbreedte + 0.50;
					partner.extraRente = partner.extraRente + 0.00;
					partner.extraMaxRente = partner.extraMaxRente + 0.00;
					makeJsonPart("2_BeginDienstverbandDt", $('#rente-werkzaamsinds-partner').val(), 0.00, 0.50, false, false);
				}else if(val < 2)
				{
					partner.extraBandbreedte = partner.extraBandbreedte + 0.50;
					partner.extraRente = partner.extraRente + 0.00;
					partner.extraMaxRente = partner.extraMaxRente + 0.00;
					makeJsonPart("2_BeginDienstverbandDt", $('#rente-werkzaamsinds-partner').val(), 0.00, 0.50, false, false);
				}else if(val >= 2 && val <= 5)
				{
					partner.extraBandbreedte = partner.extraBandbreedte + 0.20;
					partner.extraRente = partner.extraRente + 0.00;
					partner.extraMaxRente = partner.extraMaxRente + 0.00;
					makeJsonPart("2_BeginDienstverbandDt", $('#rente-werkzaamsinds-partner').val(), 0.00, 0.20, false, false);
				}else if(val > 5)
				{
					partner.extraBandbreedte = partner.extraBandbreedte + 0.00;
					partner.extraRente = partner.extraRente+ 0.00;
					partner.extraMaxRente = partner.extraMaxRente + 0.00;
					makeJsonPart("2_BeginDienstverbandDt", $('#rente-werkzaamsinds-partner').val(), 0.00, 0.00, false, false);
				}else{
					partner.extraBandbreedte = partner.extraBandbreedte + 0.50;
					partner.extraRente =  partner.extraRente+ 0.00;
					partner.extraMaxRente =  partner.extraMaxRente + 0.00;
					makeJsonPart("2_BeginDienstverbandDt", $('#rente-werkzaamsinds-partner').val(), 0.00, 0.50, false, false);
				}

				//makeJsonPart("1_BeginDienstverbandDt", $('#rente-werkzaamsinds').val(), extraRente, extraBandbreedte, false, false);

			},

			choose_person: function()
			{

				if($('#rente-burgerlijkestaat').val() == "Samenwonend" || $('#rente-burgerlijkestaat').val() == "Gehuwd")
				{
					if(hoofdaanvrager.extraMaxRente <= partner.extraMaxRente)
					{
						var val = $('#rente-dienstverband').val();
						if(val =="05" || val == "21" || val == "07")
						{
							trigger.errorText = "Het is niet mogelijk om met dit dienstverband een lening af te sluiten.";
						}
						setNewRente(hoofdaanvrager.extraRente);
						setNewBandbreedte(hoofdaanvrager.extraBandbreedte);
						setNewMaxRente(hoofdaanvrager.extraMaxRente);
						makeJsonPart("Aanvrager", "hoofdaanvrager", hoofdaanvrager.extraRente, hoofdaanvrager.extraBandbreedte, false, false);
					}else{
						var val = $('#rente-dienstverband-partner').val();
						if(val =="05" || val == "21" || val == "07")
						{
							trigger.errorText = "Het is niet mogelijk om met dit dienstverband een lening af te sluiten.";
						}
						setNewRente(partner.extraRente);
						setNewBandbreedte(partner.extraBandbreedte);
						setNewMaxRente(partner.extraMaxRente);
						makeJsonPart("Aanvrager", "partner", partner.extraRente, partner.extraBandbreedte, false, false);
					}
				}else{
					var val = $('#rente-dienstverband').val();
					if(val =="05" || val == "21" || val == "07")
					{
						trigger.errorText = "Het is niet mogelijk om met dit dienstverband een lening af te sluiten.";
					}
					setNewRente(hoofdaanvrager.extraRente);
					setNewBandbreedte(hoofdaanvrager.extraBandbreedte);
					setNewMaxRente(hoofdaanvrager.extraMaxRente);
					makeJsonPart("Aanvrager", "hoofdaanvrager", hoofdaanvrager.extraRente, hoofdaanvrager.extraBandbreedte, false, false);
				}
			},

			nettoMaandInkomen: function()
			{
				var val1 = parseInt($("#rente-inkomen").val());
				var val2 = parseInt($("#rente-inkomen-partner").val());

				if(isNaN(val2))
				{
					var val = val1;
				}else{
					var val = parseInt(parseInt($("#rente-inkomen").val()) + parseInt($("#rente-inkomen-partner").val()));
				}

				if(isNaN(val))
				{
					val = "undefined";
				}

				if(val == "undefined")
				{
					extraBandbreedte = 2.00;
					extraRente = 0.00;
					extraMaxRente = 1.00;
				}else if(val == 0)
				{
					extraBandbreedte = 2.00;
					extraRente = 0.00;
					extraMaxRente = 1.00;
				}else if(val < 1500)
				{
					extraBandbreedte = 2.00;
					extraRente = 1.00;
					extraMaxRente = 1.00;
				}else if(val >= 1500 && val <= 2500)
				{
					extraBandbreedte = 0.50;
					extraRente = 0.00;
					extraMaxRente = 0.00;
				}else if(val > 2500)
				{
					extraBandbreedte = 0.00;
					extraRente = 0.00;
					extraMaxRente = 0.00;
				}else{
					extraBandbreedte = 2.00;
					extraRente = 0.00;
					extraMaxRente = 0.00;
				}

				setNewRente(extraRente);
				setNewBandbreedte(extraBandbreedte);
				setNewMaxRente(extraMaxRente);
				makeJsonPart("1_FinancieleSituatieNettoMaandInk", $("#rente-inkomen").val(), extraRente, extraBandbreedte, false, false);
				makeJsonPart("2_FinancieleSituatieNettoMaandInk", $("#rente-inkomen-partner").val(), extraRente, extraBandbreedte, false, false);

			},

			leenervaring: function()
			{
				var val = $('#rente-leenervaring').val();
				if(val == "" || val == undefined)
				{
					extraBandbreedte = 1.00;
					extraRente = 0.00;
					extraMaxRente = 1.00;
				}else if(val == "Nee, nog nooit een lening gehad")
				{
					extraBandbreedte = 1.00;
					extraRente = 1.00;
					extraMaxRente = 1.00;
				}else if (val == "Ik heb in het verleden lening(en) gehad" || val == "Op dit moment heb ik lopende lening(en)")
				{
					extraBandbreedte = 0.00;
					extraRente = 0.00;
					extraMaxRente = 0.00;
				}else{
					extraBandbreedte = 1.00;
					extraRente = 1.00;
					extraMaxRente = 1.00;
				}

				setNewRente(extraRente);
				setNewBandbreedte(extraBandbreedte);
				setNewMaxRente(extraMaxRente);
				makeJsonPart("leenervaring", val, extraRente, extraBandbreedte, false, false);

			},

			factor: function()
			{

				var val1 = parseInt($("#rente-inkomen").val());
				var val2 = parseInt($("#rente-inkomen-partner").val());

				if(isNaN(val2))
				{
					var nettoInkomen = val1;
				}else{
					var nettoInkomen = parseInt(parseInt($("#rente-inkomen").val()) + parseInt($("#rente-inkomen-partner").val()));
				}

				if(isNaN(nettoInkomen))
				{
					nettoInkomen = "undefined";
				}

				var leenbedrag = $('#rente-leenbedrag').val();
				var val = (leenbedrag / nettoInkomen);

				if(isNaN(val))
				{
					val = "undefined";
				}

				if(val == "undefined")
				{
					extraMaxRente = 1.00;
					extraRente = 0.00;
					extraBandreedte = 0.00;
				}
				else if(val >= 0 && val < 5)
				{
					extraRente = 0.00;
					extraBandreedte = 0.00;
					extraMaxRente = 0.00;
				}else if(val >= 5 && val < 10)
				{
					extraRente = 0.20;
					extraMaxRente = 0.20;
					extraBandreedte = 0.00;
				}else if(val >= 10 && val < 15)
				{
					extraRente = 0.40;
					extraMaxRente = 0.40;
					extraBandreedte = 0.00;
				}else if(val >= 15 && val < 20)
				{
					extraRente = 0.60;
					extraMaxRente = 0.60;
					extraBandreedte = 0.00;
				}else if(val >= 20 && val <= 25)
				{
					extraRente = 0.80;
					extraMaxRente = 0.80;
					extraBandreedte = 0.00;
				}else {
					extraRente = 1.00;
					extraMaxRente = 1.00;
					extraBandreedte = 0.00;
				}

				setNewRente(extraRente);
				setNewBandbreedte(extraBandreedte);
				setNewMaxRente(extraMaxRente);
				makeJsonPart('factor', val, extraRente, extraBandreedte, false, false);
			},

			nominaal: function(rente)
			{
				return (Math.pow((1 + rente / 100),(1 / 12)) - 1) * 100;
			},

			looptijd: function(leenbedrag, nominaal, maandlast)
			{

				var x = maandlast - (leenbedrag * (nominaal / 100));

				if(x > 0)
				{
					return (Math.log(maandlast / x) / Math.log(1 + (nominaal / 100)));
				}else{
					return 180;
				}
			}

		}
	}

	function calculateGegevens()
	{
		resetRente();

		var calc = TriggerCalculator();

		calc.leenbedrag();

		calc.productkeuze();

		calc.geboortedatum();

		calc.geboortedatum_partner();

		calc.dienstverband();

		calc.dienstverband_partner();

		calc.duurDienstverband_partner();

		calc.duurDienstverband();

		calc.choose_person();

		calc.burgelijkestaat();

		calc.duurBurgelijkestaat();

		calc.woonsituatie();

		calc.duurWoonsituatie();

		calc.nettoMaandInkomen();

		calc.leenervaring();

		calc.factor();

		makeJsonPart("eindberekening", "", trigger.rente, trigger.bandbreedte, false, true);

		saveRenteObj(trigger.jsonInfo);

		displayRente(trigger.rente, trigger.maxRente, trigger.bandbreedte, trigger.errorText);
	}

	$(document).ready(function(){

		$('input').not('[name*=postcode]').keydown(function(event){
	    	if(event.keyCode == 13) {
	    		event.preventDefault();
	    	}
	 	});

		hideFieldsets();
		showFieldset(1);
		setPreventDefault(nextButton);
		setPreventDefault(backButton);
		setPreventDefault('#rente-andere-lening-add');
		setPreventDefault('.lening-delete');
		showPreviousStep();
		showNextStep();
		$(backButton).hide();
		updateFields("reset");
		calculateGegevens();

		$("input.nummer").numeric(false);

		$("input.nummer-dec").numeric(',');

		$(formName+' select').change(function(){
			updateFields($(this).attr('id'));
			calculateGegevens();
		});
		$(formName+' input').blur(function(){
			updateFields($(this).attr('id'));
			calculateGegevens();
		});

		// $('form#bereken-rente').validate({
		// });

		counter = 0;
		$('#rente-andere-lening-add').click(function(){
			counter++;
			addBox($('#rente-andere-lening-soort').val(), $('#rente-andere-lening-betalen').val(), $('#rente-andere-lening-termijn').val(), $('#rente-andere-lening-rente').val(), counter);
			saveBox($('#rente-andere-lening-soort').val(), $('#rente-andere-lening-betalen').val(), $('#rente-andere-lening-termijn').val(), $('#rente-andere-lening-rente').val(), counter);
			$('#rente-andere-lening-betalen').val(''); //empty value after submitting box
			$('#rente-andere-lening-termijn').val(''); //empty value after submitting box
			$('#rente-andere-lening-rente').val(''); //empty value after submitting box

		});
		$('a.lening-delete').live('click',function(){
			console.log($(this).attr('data-boxNo'));
			removeBoxSession($(this).attr('data-boxNo'));
			removeBox($(this).attr('data-boxNo'));
		})

		$('input#rente-offerte').live('click', function(e){
			e.preventDefault();
			var formSerialized = $('form#bereken-rente').serialize();
			saveSessionValues(formSerialized);
		});

		$('select#kennis_consumptief_krediet').change(function(){
			if($('select#kennis_consumptief_krediet').val() != "geen_kennis")
			{
				$('div.vrijblijvend-advies').show();
			}else{
				$('div.vrijblijvend-advies').hide();
			}
		});

	});
}